module.exports = "<section class=\"home-hero\">\n  <div class=\"hero-wrapper has-text-centered\">\n    <app-login-form></app-login-form>\n  </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = 1